import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerTableRow = ({ customer, onViewDetails, onViewOrders }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'inactive':
        return 'bg-muted text-muted-foreground';
      case 'vip':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return '활성';
      case 'inactive':
        return '비활성';
      case 'vip':
        return 'VIP';
      default:
        return status;
    }
  };

  return (
    <tr className="border-b border-border transition-colors hover:bg-muted/50">
      <td className="px-4 py-4">
        <div className="flex items-center space-x-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="font-medium text-foreground">{customer?.name}</p>
            <p className="text-sm text-muted-foreground">{customer?.phone}</p>
          </div>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-muted-foreground">
        {customer?.registrationDate}
      </td>
      <td className="px-4 py-4 text-center">
        <span className="inline-flex items-center justify-center rounded-full bg-accent/10 px-3 py-1 text-sm font-medium text-accent">
          {customer?.totalOrders}건
        </span>
      </td>
      <td className="px-4 py-4 text-sm text-muted-foreground">
        {customer?.lastOrderDate}
      </td>
      <td className="px-4 py-4">
        <span className="font-medium text-foreground">
          {customer?.totalSpent?.toLocaleString('ko-KR')}원
        </span>
      </td>
      <td className="px-4 py-4">
        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${getStatusColor(customer?.status)}`}>
          {getStatusLabel(customer?.status)}
        </span>
      </td>
      <td className="px-4 py-4">
        <div className="flex items-center justify-end space-x-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Eye"
            onClick={() => onViewDetails(customer)}
          >
            상세
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Package"
            onClick={() => onViewOrders(customer)}
          >
            주문
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default CustomerTableRow;